"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var developerSlice_1 = require("../../../features/developers/developerSlice");
var RegisterForm_1 = __importDefault(require("./RegisterForm"));
function Registration() {
    var dispatch = react_redux_1.useDispatch();
    var developers = react_redux_1.useSelector(developerSlice_1.selectDevelopers);
    react_2.useEffect(function () {
        dispatch(developerSlice_1.fetchDevelopers());
    }, []);
    return react_1.default.createElement(RegisterForm_1.default, { developers: developers });
}
exports.default = Registration;
